import { render, staticRenderFns } from "./DiscrepancyPicker.vue?vue&type=template&id=8f7d2976&scoped=true&"
import script from "./DiscrepancyPicker.vue?vue&type=script&lang=ts&"
export * from "./DiscrepancyPicker.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8f7d2976",
  null
  
)

export default component.exports